var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasePannelliIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h32v-32h-32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14501"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h32v-32h-32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14537"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h32v-32h-32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.301 20.468h15.611v-6.8642h-15.611z",
    fill: "#008768"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 .555 7.0355)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.493 3.687h-30.987v4.393h30.987z",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 14.286 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 16.424 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 18.561 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 20.698 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 .555 7.0355)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.078 8.0799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.3239,8.0799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.818-1.08",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.2468,8.0799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 5.737 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 7.8743 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 10.012 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 12.149 13.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.325-4.393",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 .555 7.0355)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14537)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.494 4.7466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.802-1.06",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 4.1396 13.604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v20",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71693 0 0 .79017 19.912 13.604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v20",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasePannelliIcon);
export default __webpack_public_path__ + "static/media/BasePannelliIcon.2f14d34c8817e04495038d2c4fbba6e2.svg";
export { ForwardRef as ReactComponent };